
import 'jquery-match-height';
import {App} from './lib/app';

import Vue from 'vue'
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';

if (window.environments.env !== 'DEV' && window.environments.sentry_dsn) {
	const config = {
		release: window.environments.release,
		environment: window.environments.env
	};
	Raven.config(window.environments.sentry_dsn, config).
		addPlugin(RavenVue, Vue).
		install();
}

const app = new App();

// Match Height settings
app.matchHeight.selector = [
	'.block--icon__title',
	'.block--promo__title',
];

// Tooltips settings
app.tooltips.selector = '[rel~=tooltip]';
app.tooltips.id = 'tooltip';

app.init();


import 'owl.carousel';
import 'owl.carousel2.thumbs';
import 'lightgallery/wp-content/themes/litea/dist/js/lightgallery.min';

jQuery(function ($) {

	$(function () {
		$('.card__content').matchHeight({
			byRow: true,
			property: 'height',
			target: null,
			remove: false,
		});
	});


	$('#lightgallery').lightGallery({
		selector: '.item-l',
		subHtmlSelectorRelative: true
	});

	$('#gallery').lightGallery({
		selector: '.gallery-filter-lightbox',
		subHtmlSelectorRelative: true
    });
});

var width = $(window).width();


// Navigation
// if (width < 992) {
// 	$(document).on('click', '.hamburger', function () {
// 		$('nav').toggleClass('active').slideToggle();
// 		$(this).toggleClass('active');
// 	});
// 	$(document).on('click', '.hamburger, nav', function (e) {
// 		e.stopPropagation();
// 	});
// 	$(document).on('click', function () {
// 		$('nav').removeClass('active').slideUp();
// 		$('.hamburger').removeClass('active');
// 	});
//
//
// 	$('.sub-show').on('mouseover', (function () {
// 		var button = $(this).parent().find('.sub-menu').first();
// 		if (!button.hasClass('active-subshow')) {
// 			button.slideDown(500);
// 		} else {
// 			button.slideUp(500);
// 		}
// 		button.toggleClass('active-subshow');
// 		$(this).toggleClass('active');
// 	}));
// }

// Carousel
$(document).ready(function () {
	$('.owl-carousel--promo').owlCarousel({
		items: 1,
		nav: true,
		dots: false,
	});

	$('.owl-carousel--single').owlCarousel({
		items: 1,
		nav: true,
		dots: false,
		loop: true,
		thumbs: true,
		thumbsPrerendered: true,
	});

	$('.owl-carousel--artists').owlCarousel({
		items: 5,
		loop: false,
		nav: true,
		autoWidth: true,
		margin: 15,
	});

	if (width < 991) {
		$('.owl-carousel--concert').owlCarousel({
			margin: 10,
			nav: false,
			dots: false,
			loop: false,
			autoWidth: true,
			responsiveClass: true,
			responsive: {
				0: {
					items: 2,
				},
				500: {
					items: 2,
				},
			},
		});
	}
});

// Sticky header
window.onscroll = function () {
	myFunction();
};

var header = document.getElementById('myHeader');
var sticky = 50;

function myFunction() {
	if (window.pageYOffset >= sticky) {
		header.classList.add('sticky');
	} else {
		header.classList.remove('sticky');
	}
}

const accButton = document.getElementsByClassName('accordeon--button');
const accContent = document.getElementsByClassName('accordeon--content');
const accContentLarge = document.getElementsByClassName('accordeon--content-large');

for (let i = 0; i < accButton.length; i++) {
	accButton[i].addEventListener('click', function () {
		if (accButton[i].classList.contains('active')) {
			accButton[i].classList.remove('active');
			accButton[i].innerHTML = concertBtnText;

		} else {
			accButton[i].classList.add('active');
			accButton[i].innerHTML = concertBtnData;
		}

		if ((accContent[i].style.maxHeight)) {
			accContent[i].style.maxHeight = null;
		} else {
			accContent[i].style.maxHeight = accContent[i].scrollHeight + 'px';
		}

	});

	const concertBtnText = accButton[i].textContent;
	const concertBtnData = accButton[i].getAttribute('data-text');

	if(accContent.length) {
		if (accContent[i].offsetHeight < 90) {
			accButton[i].style.display = 'none';
		}
	}

	if(accContentLarge.length) {
		if (accContentLarge[i].offsetHeight < 440) {
			accButton[i].style.display = 'none';
		}
	}
}

// Search Button
let searchButton = document.getElementById('btn-search');

if (searchButton) {
	searchButton.addEventListener('click', e => {
		if (!searchButton.classList.contains('active')) {
			searchButton.classList.add('active');
		} else if (!e.target.classList.contains('search-field')) {
			searchButton.classList.remove('active');
		}
	});
}
document.addEventListener('click', e => {
	if (searchButton) {
		if (!e.target.classList.contains('search-field') && e.target.id != 'btn-search') {
			searchButton.classList.remove('active');
		}
	}
});